import React from "react";
import { useQuery } from "react-query";
import { getPromo } from "../../hooks/promo";
import HomePromo from "../HomePromo/HomePromo";

const promoId = "cm8rstyqa0000cak83z8rb71v";

const Crucero = ({ image }) => {
  const { data: crucero, isLoading } = useQuery(["crucero"], () => getPromo(promoId));

  if (isLoading) return <div>Loading promo...</div>;

  function handlePromo() {
    window.open(`${crucero.link}`, "_blank");
  }

  return (
    <HomePromo
      type="CRUCEROS"
      image={image}
      title="OFERTAS"
      subtitle="Escoge y compara tus opciones de cruceros."
      click={() => handlePromo()}
    />
  );
};

export default Crucero;
